export default "__VITE_ASSET__6f367438__"